import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsTargetProducts: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCTS,
	},
	getRegulationsTargetProductPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT_PREVIEW,
	},
	getRegulationsTargetProductPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT_POPUP,
	},
	createRegulationsTargetProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].CREATE_REGULATIONS_TARGET_PRODUCT,
	},
	getRegulationsTargetProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].GET_REGULATIONS_TARGET_PRODUCT,
	},
	patchRegulationsTargetProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].PATCH_REGULATIONS_TARGET_PRODUCT,
	},
	putRegulationsTargetProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].PUT_REGULATIONS_TARGET_PRODUCT,
	},
	deleteRegulationsTargetProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_TARGET_PRODUCTS].DELETE_REGULATIONS_TARGET_PRODUCT,
	},
}